"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import Pagination from '@/components/component_astro_crick/pagination';
import { getImageUrl } from '@/lib/api';
interface ImageMetadata {
  width?: number;
  height?: number;
  'focus-point'?: [number, number];
}
interface PhotoElement {
  id: string;
  title?: string;
  imageS3Key?: string;
  text?: string;
  imageMetadata?: ImageMetadata;
  attribution?: string;
}
interface HeroImage {
  imageS3Key: string;
  imageMetadata?: ImageMetadata;
  title?: string;
  attribution?: string;
}
interface PhotoCarouselProps {
  photos: PhotoElement[];
  heroImage?: HeroImage;
  maxHeight?: number;
  containerClassName?: string;
}
export default function PhotoCarousel(t0) {
  const $ = _c(59);
  const {
    photos,
    heroImage,
    maxHeight,
    containerClassName
  } = t0;
  const [currentPage, setCurrentPage] = useState(1);
  let currentImage;
  let goToNext;
  let goToPrevious;
  let handlePageChange;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let totalPages;
  if ($[0] !== containerClassName || $[1] !== currentPage || $[2] !== heroImage || $[3] !== maxHeight || $[4] !== photos) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const storyImages = photos.filter(_temp);
      const allImages = [];
      if (heroImage?.imageS3Key) {
        allImages.push({
          id: "hero-image",
          title: heroImage.title,
          imageS3Key: heroImage.imageS3Key,
          imageMetadata: heroImage.imageMetadata,
          attribution: heroImage.attribution
        });
      }
      allImages.push(...storyImages);
      totalPages = allImages.length;
      currentImage = allImages[currentPage - 1];
      let t7;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = page => {
          setCurrentPage(page);
        };
        $[16] = t7;
      } else {
        t7 = $[16];
      }
      handlePageChange = t7;
      let t8;
      if ($[17] !== currentPage) {
        t8 = () => {
          if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
          }
        };
        $[17] = currentPage;
        $[18] = t8;
      } else {
        t8 = $[18];
      }
      goToPrevious = t8;
      let t9;
      if ($[19] !== currentPage || $[20] !== totalPages) {
        t9 = () => {
          if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
          }
        };
        $[19] = currentPage;
        $[20] = totalPages;
        $[21] = t9;
      } else {
        t9 = $[21];
      }
      goToNext = t9;
      const hasFocusPoint = _temp2;
      let t10;
      if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = metadata_0 => {
          if (!hasFocusPoint(metadata_0)) {
            return {};
          }
          const [focusX, focusY] = metadata_0["focus-point"];
          const xPercent = focusX / metadata_0.width * 100;
          const yPercent = focusY / metadata_0.height * 100;
          return {
            objectPosition: `${xPercent}% ${yPercent}%`
          };
        };
        $[22] = t10;
      } else {
        t10 = $[22];
      }
      const getFocusPointStyle = t10;
      const getAspectRatio = _temp3;
      if (allImages.length === 0) {
        t6 = null;
        break bb0;
      }
      const metadata_2 = currentImage.imageMetadata;
      const showFocusedView = hasFocusPoint(metadata_2);
      getFocusPointStyle(metadata_2);
      getAspectRatio(metadata_2);
      t5 = "w-full";
      t1 = `relative w-full group overflow-hidden ${containerClassName || ""}`;
      if ($[23] !== containerClassName || $[24] !== maxHeight) {
        t2 = !containerClassName && maxHeight ? {
          maxHeight: `${maxHeight}px`
        } : {};
        $[23] = containerClassName;
        $[24] = maxHeight;
        $[25] = t2;
      } else {
        t2 = $[25];
      }
      let t11;
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
          filter: "blur(20px)"
        };
        $[26] = t11;
      } else {
        t11 = $[26];
      }
      t3 = <img src={getImageUrl(currentImage.imageS3Key)} alt="" className="absolute inset-0 w-full h-full object-cover blur-xl scale-110" style={t11} aria-hidden="true" />;
      t4 = showFocusedView ? <div className="relative w-full h-full" style={{
        aspectRatio: maxHeight ? undefined : "4 / 3",
        height: maxHeight ? "100%" : undefined
      }}><img src={getImageUrl(currentImage.imageS3Key)} alt={currentImage.title || `Photo ${currentPage}`} className="w-full h-full object-contain" style={{
          maxHeight: maxHeight ? `${maxHeight}px` : undefined
        }} loading="lazy" /></div> : <div className="relative w-full" style={{
        aspectRatio: maxHeight ? undefined : metadata_2?.width && metadata_2?.height ? `${metadata_2.width} / ${metadata_2.height}` : "16 / 9",
        maxHeight: maxHeight ? `${maxHeight}px` : undefined
      }}><img src={getImageUrl(currentImage.imageS3Key)} alt={currentImage.title || `Photo ${currentPage}`} className="w-full h-full object-contain" style={{
          maxHeight: maxHeight ? `${maxHeight}px` : undefined
        }} loading="lazy" /></div>;
    }
    $[0] = containerClassName;
    $[1] = currentPage;
    $[2] = heroImage;
    $[3] = maxHeight;
    $[4] = photos;
    $[5] = currentImage;
    $[6] = goToNext;
    $[7] = goToPrevious;
    $[8] = handlePageChange;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = totalPages;
  } else {
    currentImage = $[5];
    goToNext = $[6];
    goToPrevious = $[7];
    handlePageChange = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    totalPages = $[15];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[27] !== currentPage || $[28] !== goToPrevious || $[29] !== totalPages) {
    t7 = totalPages > 1 && <button onClick={goToPrevious} disabled={currentPage === 1} className={`absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black bg-opacity-50 hover:bg-opacity-70 transition-all ${currentPage === 1 ? "opacity-30 cursor-not-allowed" : "opacity-70 hover:opacity-100 cursor-pointer"}`} aria-label="Previous image"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="white" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg></button>;
    $[27] = currentPage;
    $[28] = goToPrevious;
    $[29] = totalPages;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== currentPage || $[32] !== goToNext || $[33] !== totalPages) {
    t8 = totalPages > 1 && <button onClick={goToNext} disabled={currentPage === totalPages} className={`absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black bg-opacity-50 hover:bg-opacity-70 transition-all ${currentPage === totalPages ? "opacity-30 cursor-not-allowed" : "opacity-70 hover:opacity-100 cursor-pointer"}`} aria-label="Next image"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="white" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg></button>;
    $[31] = currentPage;
    $[32] = goToNext;
    $[33] = totalPages;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== currentPage || $[36] !== totalPages) {
    t9 = totalPages > 1 && <div className="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-sm px-3 py-1 rounded-full">{currentPage} / {totalPages}</div>;
    $[35] = currentPage;
    $[36] = totalPages;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== t1 || $[39] !== t2 || $[40] !== t3 || $[41] !== t4 || $[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
    t10 = <div className={t1} style={t2}>{t3}{t4}{t7}{t8}{t9}</div>;
    $[38] = t1;
    $[39] = t2;
    $[40] = t3;
    $[41] = t4;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  let t11;
  if ($[46] !== currentImage.attribution || $[47] !== currentImage.text || $[48] !== currentImage.title) {
    t11 = (currentImage.title || currentImage.text || currentImage.attribution) && <div className="bg-[#1a237e] p-4">{currentImage.title && <p className="text-white text-lg font-semibold mb-2">{currentImage.title}</p>}{currentImage.text && <div className="text-white text-sm leading-relaxed" dangerouslySetInnerHTML={{
        __html: currentImage.text
      }} />}{currentImage.attribution && <p className="text-white text-sm text-right">{currentImage.attribution}</p>}</div>;
    $[46] = currentImage.attribution;
    $[47] = currentImage.text;
    $[48] = currentImage.title;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  let t12;
  if ($[50] !== currentPage || $[51] !== handlePageChange || $[52] !== totalPages) {
    t12 = totalPages > 1 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} scrollToTop={false} />;
    $[50] = currentPage;
    $[51] = handlePageChange;
    $[52] = totalPages;
    $[53] = t12;
  } else {
    t12 = $[53];
  }
  let t13;
  if ($[54] !== t10 || $[55] !== t11 || $[56] !== t12 || $[57] !== t5) {
    t13 = <div className={t5}>{t10}{t11}{t12}</div>;
    $[54] = t10;
    $[55] = t11;
    $[56] = t12;
    $[57] = t5;
    $[58] = t13;
  } else {
    t13 = $[58];
  }
  return t13;
}
function _temp3(metadata_1) {
  if (metadata_1?.width && metadata_1?.height) {
    return `${metadata_1.width} / ${metadata_1.height}`;
  }
  return "16 / 9";
}
function _temp2(metadata) {
  return !!(metadata?.["focus-point"] && metadata.width && metadata.height);
}
function _temp(photo) {
  return photo.imageS3Key;
}